var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FormHelperErrorDescription } from '@juvare/common-form-ui/WidgetForm/Components';
import { getVisibleError, handleWidgetUpdate, renderForm } from '@juvare/common-form-ui/WidgetForm/Utils';
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import { FormControl, TextField } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { type } from './types';
export const WidgetPhinIdentifier = (props) => {
    var _a, _b, _c;
    const { t } = useAlertUiTranslation();
    const error = getVisibleError(props);
    const functionClient = useFunctionClient();
    const getUniqueIdentifier = () => __awaiter(void 0, void 0, void 0, function* () {
        const configurationUniqueIdentifier = yield functionClient.executeFunction({
            functionName: 'getPhinMessageUniqueIdentifier',
        });
        return configurationUniqueIdentifier.result;
    });
    React.useEffect(() => {
        if (props.config.generateUniqueIdentifier) {
            getUniqueIdentifier()
                .then((v) => {
                props.setData(v);
                renderForm(props, { changed: true });
            })
                .catch(console.error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(FormControl, { variant: 'outlined', fullWidth: true, required: (_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required, error: !!error },
        React.createElement(TextField, { size: 'medium', margin: 'dense', label: t('pages.edit.uniqueIdentifier'), "aria-label": t('pages.edit.uniqueIdentifier'), type: 'text', required: (_b = props.config.validate) === null || _b === void 0 ? void 0 : _b.required, disabled: (_c = props.config) === null || _c === void 0 ? void 0 : _c.disabled, fullWidth: true, variant: 'outlined', value: props.getDataString(), error: !!error, sx: { backgroundColor: 'background.paper' }, onChange: (event) => {
                props.setData(event.target.value);
                renderForm(props, { changed: true });
            }, "data-test": 'unique-identifier-input' }),
        React.createElement(FormHelperErrorDescription, { error: error })));
};
const WidgetPhinIdentifierEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props),
        React.createElement(WidgetPhinIdentifier, Object.assign({}, props))));
};
export const widgetPhinIdentifier = {
    type,
    createWidget: () => ({
        type,
        key: 'phinIdentifier',
    }),
    validate: (props) => {
        var _a, _b;
        const value = props.getDataStringOrUndefined();
        return !value ? ((_b = (_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.requiredMessage) !== null && _b !== void 0 ? _b : 'Unique Identifier is required') : undefined;
    },
    update: handleWidgetUpdate,
    component: WidgetPhinIdentifier,
    editorComponent: WidgetPhinIdentifierEditor,
    icon: React.createElement(MonitorHeartOutlinedIcon, null),
};
